// Saved CSC working sets — the last few, kept so one can be opened again.
//
// The CSC tab already autosaves a draft, but that is one slot in sessionStorage: it is
// overwritten by the next thing typed and gone when the tab closes. It answers "don't
// lose my work while I navigate", not "let me go back to the quote I did this morning".
// (user 2026-10-23: "can we have a record history of 5? And we can save it so we can
//  refr back?")
//
// localStorage, not sessionStorage, because the whole point is surviving the tab closing.
// Per browser profile, never sent anywhere — this is a scratchpad, not a record of a sale.
// A sale is the system's record; these are the workings behind one.

const KEY = 'csc_history_v1';

// Ten (user asked for five, then "Or save 10?" — 2026-10-23). The number is only this
// constant, so it can move again without touching anything else.
//
// A cap matters at all because each entry is a whole working set and localStorage is a
// few MB per origin: unbounded history eventually throws on save and loses the lot.
export const CSC_HISTORY_MAX = 10;

/** Everything saved, newest first. Never throws — a corrupt store reads as empty. */
export function loadCscHistory() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter(e => e && e.id && e.data) : [];
    } catch {
        return [];
    }
}

function write(list) {
    try {
        localStorage.setItem(KEY, JSON.stringify(list.slice(0, CSC_HISTORY_MAX)));
        return true;
    } catch {
        // Quota, or a private window that refuses writes. The caller tells the user; it
        // must not take the page down with it.
        return false;
    }
}

/**
 * Save a working set. Returns the new list.
 *
 * Saving the SAME customer twice replaces the earlier entry rather than filling the five
 * slots with one name — re-saving after a tweak is the common case, and it should not
 * push the other four out.
 */
export function pushCscHistory({ label, subtitle, data }) {
    const list = loadCscHistory();
    const key = String(label || '').trim().toLowerCase();
    const kept = key ? list.filter(e => String(e.label || '').trim().toLowerCase() !== key) : list;
    const entry = {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        savedAt: new Date().toISOString(),
        label: label || 'Untitled',
        subtitle: subtitle || '',
        data,
    };
    const next = [entry, ...kept].slice(0, CSC_HISTORY_MAX);
    write(next);
    return next;
}

/** Drop one entry. Returns the new list. */
export function removeCscHistory(id) {
    const next = loadCscHistory().filter(e => e.id !== id);
    write(next);
    return next;
}

/** "22 Oct, 4:35 pm" — short enough for a menu row, unambiguous within a few days. */
export function formatSavedAt(iso) {
    try {
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) return '';
        return d.toLocaleString('en-MY', {
            day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true,
        });
    } catch {
        return '';
    }
}
